import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PanelLeft } from "lucide-react";
import { cn } from "lib/utils";
import SettingsSidebar from "./Components/SettingsSidebar/SettingsSidebar";
import ProfileSection from "./Components/ProfileSection/ProfileSection";
import AccountSection from "./Components/AccountSection/AccountSection";
import styles from "./Settings.module.scss";

const SettingsPage = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "profile";
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className={cn(styles.settingsContainer, "flex flex-1 w-full bg-gray-50/30 overflow-hidden")}>
      {/* Settings Navigation Sidebar */}
      <SettingsSidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main Content Area */}
      <div className={cn(styles.mainPanel, "flex-1 flex flex-col min-w-0 h-full overflow-y-auto relative")}>
        {/* Toggle bar when sidebar is collapsed */}
        {sidebarCollapsed && (
          <div className="flex items-center gap-3 px-6 pt-5 w-full">
            <button
              onClick={() => setSidebarCollapsed(false)}
              className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-200 border border-gray-200 rounded-md transition-colors"
              title="Open Settings Menu"
            >
              <PanelLeft size={18} />
            </button>
            <h2 className="text-xl font-semibold text-gray-900 m-0">Settings</h2>
          </div>
        )}

        <div
          className={cn(
            styles.contentWrapper,
            "flex-1 flex flex-col w-full",
            sidebarCollapsed ? "pb-8 pt-4 px-6" : "py-6 px-6 lg:px-10"
          )}
        >
          {activeTab === "profile" && <ProfileSection />}
          {activeTab === "account" && <AccountSection />}
          {!["profile", "account"].includes(activeTab) && (
            <ProfileSection />
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
